<script>
import SeoMixin from '~/sites/shop/mixins/SeoMixin'

export default {
  extends: SeoMixin,
  methods: {
    sendViewEventPage() {
      //
    },
    getFavicons() {
      return [{ rel: 'icon', type: 'image/x-icon', href: '/favicon/oknanebodvere-favicon.png' }]
    },
    getSeoLinkCanonical() {
      const isProductWithDimensions = this.$route.path.match(/\/produkt\/.*-\d+-\d+$/)

      if (isProductWithDimensions) {
        return []
      }

      return [
        {
          rel: 'canonical',
          href: this.makeAbsoluteUrl(this.$route.path),
        },
      ]
    },
  },
}
</script>
